import { translate } from 'src/app/project/features/translate/translate';

export function formatPointFlag(type: string): string {
  return type === 'xlsx' ? '🚩' : translate('flagged');
}
